import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Container, Row } from "react-bootstrap";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import styled from "styled-components";
import DataObj from "../../class/DataObj";
import WaveformView from "../drogable/WaveformView";

const FormtitleLable = styled.div`
  margin-top: 5px;
  position: relative;
  text-align: center;
  width: ${(props) => props.width}px;
`;
const IconLable = styled.button`
  border-radius: 3px;
  text-align: center;
  padding: 1px 3px;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`;

class IgnoreBtnView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Timecode的位置
      timecode_top: -1000,
      timecode_left: -1000,
      readOnly: false,
    };
    this.setPosition = this.setPosition.bind(this);
  }

  //設定位置
  setPosition(type, top, left) {
    this.setState({ timecode_top: top });
    this.setState({ timecode_left: left });
  }
  async componentDidMount() {
    this.props.onRef(this);
    this.setState({ readOnly: this.props.readOnly });
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  async componentWillReceiveProps(nextProps) {
    this.setState({ readOnly: nextProps.readOnly });
  }
  render() {
    const { _WaveformView } = this.props;

    const Timecode = styled.div`
      text-align-last: justify;
      width: 70px;
      position: absolute;
      top: ${(props) => props.top}px;
      left: ${(props) => props.left}px;
      z-index: 100;
    `;

    const SubtitleView = styled.div`
      text-align-last: justify;
      width: 285px;
      position: absolute;
      top: ${(props) => props.top}px;
      left: ${(props) => props.left}px;
      z-index: 100;
    `;

    return (
      <SubtitleView
        top={this.state.timecode_top}
        left={this.state.timecode_left}
        ref={(c) => (this.igonreComponent = c)}
        id="igonre-buttons"
      >
        <Container className={"p-0 m-0"}>
          <Row className={"p-0 m-0"}>
            <Button
              style={{
                fontSize: "10px",

                padding: "1px",
              }}
              onClick={async () => {
                const targetIndex = _WaveformView.cellCoords_row;
                const data = _WaveformView.DataObjArray.getContent();
                let dataObj = new DataObj(data[targetIndex]);
                dataObj.setTSubType(WaveformView.projectSubType);

                await dataObj.setIsIgnoreShotchange(true);
  
                await _WaveformView.DataObjArray.updateDataObj_by_index(
                  targetIndex,
                  dataObj
                ); 
                await _WaveformView.saveData_update_EditTable_ITManPlayer_WaveGroup(
                  _WaveformView.DataObjArray.getContent()
                );

                await _WaveformView.setIsEdit(true);

                // 在更新一次錯誤的
                await _WaveformView.props.updateShotChangeData(
                  _WaveformView.DataObjArray.getContent(),
                  _WaveformView.shotchangeData
                );
                
              }}
            >
              ignore
            </Button>
          </Row>
        </Container>
      </SubtitleView>
    );
  }
}

IgnoreBtnView.propTypes = {};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(withRouter(IgnoreBtnView));



// WEBPACK FOOTER //
// ./src/components/common/IgnoreBtnView.js